import { Component, Input } from '@angular/core';
import {
  ContentConfiguration,
  HeaderContentDirections,
  HeaderContentGridConfiguration,
} from './header-content-grid.constants';

@Component({
  selector: 'header-content-grid',
  templateUrl: './header-content-grid.component.html',
  styleUrls: ['./header-content-grid.component.scss'],
})
export class HeaderContentGridComponent {
  @Input() contentMap: ContentConfiguration;

  @Input()
  public set config(config: HeaderContentGridConfiguration) {
    this._config = new HeaderContentGridConfiguration(config);
  }

  public get config(): HeaderContentGridConfiguration {
    return this._config;
  }

  _config: HeaderContentGridConfiguration;
  HeaderContentDirections = HeaderContentDirections;
}
